export const fragmentContentById = (name, data, contentMap) => {
  const _id = contentMap.indexOf(name);
  return data.cmsBlocks.items[_id].content.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
};
